/**
 * What an order costs. The API charges with these functions and the browser
 * shows totals with the same ones, so the two cannot disagree. Every amount
 * is in whole cents, so no sum rounds.
 */
export const Pricing = {
    /** Stripe's smallest charge in euros, which every order total has to reach. */
    MINIMUM_TOTAL_CENTS: 50,
    /** Stripe's largest charge in euros, which also keeps every order sum inside its integer column. */
    MAXIMUM_TOTAL_CENTS: 99_999_999,
    lineTotal: (line) => line.unitPriceCents * line.quantity,
    subtotal: (lines) => lines.reduce((sum, line) => sum + Pricing.lineTotal(line), 0),
    /** An option with a free-from threshold ships free once the subtotal reaches it. */
    shipping: (option, subtotalCents) => option.freeFromCents !== undefined && subtotalCents >= option.freeFromCents ? 0 : option.priceCents,
    /** How much more the subtotal needs before `option` ships free; `undefined` when it never does. */
    untilFree: (option, subtotalCents) => option.freeFromCents === undefined ? undefined : Math.max(0, option.freeFromCents - subtotalCents),
    totals: (lines, option) => {
        const subtotalCents = Pricing.subtotal(lines);
        const shippingCents = Pricing.shipping(option, subtotalCents);
        return { subtotalCents, shippingCents, totalCents: subtotalCents + shippingCents };
    },
};
//# sourceMappingURL=pricing.js.map